import React from 'react'
import { Container, TextBody } from '@pmi/pmi-iqos-ds-react'
import { htmlTranslation } from '@pmi/pmi-iqos-shared-react'

const SurveyLinks = ({
  translations,
  links,
  redirectToChoice,
  bottomLabels
}) => {
  return (
    <Container
      display={Container.displays.flex}
      justifyContent={Container.justifyContentValues.around}>
      <Container>
        {bottomLabels && (
          <Container
            display={[Container.displays.block, Container.displays.none]}
            fullWidth
            pb="4">
            <TextBody
              alignment={TextBody.alignments.right}
              size={TextBody.sizes.s}
              style={TextBody.styles.grayedout}
              {...htmlTranslation(translations, 'tk_feedbackFormRightLabel')}
            />
          </Container>
        )}
        {!bottomLabels && (
          <Container
            fullWidth
            pt="4"
            display={Container.displays.flex}
            justifyContent={Container.justifyContentValues.between}>
            <Container pr="2">
              <TextBody
                size={TextBody.sizes.s}
                style={TextBody.styles.grayedout}
                {...htmlTranslation(translations, 'tk_feedbackFormLeftLabel')}
              />
            </Container>
            <Container
              display={[Container.displays.none, Container.displays.block]}
              pl="2">
              <TextBody
                size={TextBody.sizes.s}
                style={TextBody.styles.grayedout}
                {...htmlTranslation(translations, 'tk_feedbackFormRightLabel')}
              />
            </Container>
          </Container>
        )}
        <Container
          fullWidth
          display={Container.displays.flex}
          justifyContent={Container.justifyContentValues.between}>
          {Object.values(links).map((link, index) => {
            return (
              <Container
                key={`feedback-${index}`}
                pl={index ? ['1', '2', '4'] : ''}>
                <Container
                  borderColor={Container.borderColors.default}
                  width={['6', '9', '10']}
                  height="10"
                  display={Container.displays.flex}
                  justifyContent={Container.justifyContentValues.center}
                  alignItems={Container.alignItemsValues.center}
                  onClickHandler={() => {
                    redirectToChoice(link)
                  }}
                  data-testing="Checkout_Layout_Feedback">
                  <TextBody size={TextBody.sizes.s}>{index}</TextBody>
                </Container>
              </Container>
            )
          })}
        </Container>
        {bottomLabels && (
          <Container
            fullWidth
            pt="4"
            display={Container.displays.flex}
            justifyContent={Container.justifyContentValues.between}>
            <Container pr="2">
              <TextBody
                size={TextBody.sizes.s}
                style={TextBody.styles.grayedout}
                {...htmlTranslation(translations, 'tk_feedbackFormLeftLabel')}
              />
            </Container>
            <Container
              display={[Container.displays.none, Container.displays.block]}
              pl="2">
              <TextBody
                size={TextBody.sizes.s}
                style={TextBody.styles.grayedout}
                {...htmlTranslation(translations, 'tk_feedbackFormRightLabel')}
              />
            </Container>
          </Container>
        )}
        {!bottomLabels && (
          <Container
            display={[Container.displays.block, Container.displays.none]}
            fullWidth
            pb="4">
            <TextBody
              alignment={TextBody.alignments.right}
              size={TextBody.sizes.s}
              style={TextBody.styles.grayedout}
              {...htmlTranslation(translations, 'tk_feedbackFormRightLabel')}
            />
          </Container>
        )}
      </Container>
    </Container>
  )
}

export default SurveyLinks
